import { API_ENDPOINT_MARKETPLACE_NOTIFICATIONS } from '../Constants';
import BaseMarketplaceService from './BaseMarketplaceService';

export default class NotificationsService extends BaseMarketplaceService {
  async getUserNotifications() {
    const headers = await this.getAuthHeaders();
    try {
      const response = await fetch(API_ENDPOINT_MARKETPLACE_NOTIFICATIONS, { headers });
      if (!response.ok) {
        console.warn('Notifications endpoint not yet available');
        return { notifications: [] };
      }
      return await response.json();
    } catch (error) {
      console.warn('Notifications endpoint error:', error);
      return { notifications: [] };
    }
  }
}

